






import Vue from 'vue'
export default Vue.extend({
  name: 'UnderlineTextButton.vue',
  props: {
    text: String,
    fontSize: {
      type: String,
      default: '1.25rem'
    }
  }
})
